import * as React from "react";
import styled from "@mui/material/styles/styled";
import { useClinicData } from "../clinic/clinicHooks";
import { LocalStorageSettingsPage } from "fe-web-components/settings/newSettings/localSroageSettingsPage";
//region [[ Styles ]]
const PatientSettingsPageView = styled("div")(({ theme }) => ({}));
//endregion [[ Styles ]]
//region [[ Props ]]
export interface PatientSettingsPageProps {}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const PatientSettingsPage = ({ ...props }: PatientSettingsPageProps) => {
  const clinicData = useClinicData();
  return (
    <PatientSettingsPageView>
      <LocalStorageSettingsPage clinicData={clinicData} />
    </PatientSettingsPageView>
  );
};
